import {
  DASHBOARD_ALERT_TYPES,
  DASHBOARD_PATH_SEGMENTS,
  DASHBOARD_SCOPE_NATION,
  type DashboardAlertType,
} from '@features/dashboard/constants/dashboardAlerts';
import { getApiScopeFromValue, getScopeFromValue } from '@features/invitations/utils/getScopeFromParam';
import { buildReportViewSearch } from '@core/reports/constants/reportSpaQueryParams';

export type DashboardScope = 'CHURCH' | 'DISTRICT' | 'NATION';

function basePath(scope: string, scopeId: number): string {
  return `/${getApiScopeFromValue(scope)}/${scopeId}`;
}

export function alertPath(
  type: string,
  scope: string,
  scopeId: number
): string | null {
  switch (type as DashboardAlertType) {
    case DASHBOARD_ALERT_TYPES.PERSONAL_INVITE_PENDING:
      return '/pending-invitations';
    case DASHBOARD_ALERT_TYPES.DEADLINE_URGENT:
    case DASHBOARD_ALERT_TYPES.DEADLINE_PASSED:
      return null;
    case DASHBOARD_ALERT_TYPES.TAG_REOPEN_REQUESTED:
      return getScopeFromValue(scope) === DASHBOARD_SCOPE_NATION
        ? tagsPath(scopeId)
        : null;
    default:
      return null;
  }
}

export function departmentProgressPath(
  scope: string,
  scopeId: number,
  reportTagId: number,
  departmentId: number
): string {
  const params = buildReportViewSearch({ departmentId, reportTagId });
  const root = basePath(scope, scopeId);
  return `${root}/reports/view?${params}`;
}

export function financeSnapshotMembershipPath(scope: string, scopeId: number): string {
  const root = basePath(scope, scopeId);
  const segment =
    scope.toUpperCase() === 'NATION'
      ? 'my-nation'
      : scope.toUpperCase() === 'DISTRICT'
        ? 'my-district'
        : 'my-church';
  return `${root}/${segment}`;
}

export function financeSnapshotDepartmentReportPath(
  scope: string,
  scopeId: number,
  reportTagId: number,
  departmentId: number
): string {
  return departmentProgressPath(scope, scopeId, reportTagId, departmentId);
}

export function invitesPath(scope: string, scopeId: number): string {
  return `${basePath(scope, scopeId)}/invites`;
}

export function departmentReportsDraftPath(scope: string, scopeId: number): string {
  return `${basePath(scope, scopeId)}/department-reports/draft`;
}

export function activitySubmitPath(scope: string, scopeId: number): string {
  return `${basePath(scope, scopeId)}/reports/submit`;
}

export function kpiPath(scopeId: number): string {
  return `/nation/${scopeId}/kpi`;
}

export function tagsPath(nationId: number): string {
  return `/${getApiScopeFromValue(DASHBOARD_SCOPE_NATION)}/${nationId}/${DASHBOARD_PATH_SEGMENTS.TAGS}`;
}

export function financeDeductiblesPath(scopeId: number): string {
  return `/nation/${scopeId}/finance/deductibles`;
}

export function financeCategoriesPath(scopeId: number): string {
  return `/nation/${scopeId}/finance/categories`;
}

export function allocationRulesPath(scopeId: number): string {
  return `/nation/${scopeId}/finance/allocation-rules`;
}
